module.exports = __webpack_public_path__ + "img/paper03.205126b1.jpeg";